console.log("custom js loaded");
const formEmbedControl = (timeout) => {
    setTimeout(() => {  
        let embed = document.querySelector('form-embed');
        if(!embed) {
            formEmbedControl(100);
        }else{
            console.log(embed);
            embed.shadowRoot.querySelector('span').style.display="none";
            let embedFormButtons = document.querySelectorAll('.embed-form-button');
            console.log(embedFormButtons);
            for (const button of embedFormButtons) {
                button.addEventListener('click', () => embed.shadowRoot.querySelector('button').click())
            }
            embed.shadowRoot.querySelector('button').addEventListener('click', () => {
                setTimeout(() => {
                    console.log("form embed showed", embed.shadowRoot.querySelector('[data-testid="btn-close"]'));
                    embed.shadowRoot.querySelector('[data-testid="btn-close"]').addEventListener('click', () => {
                        setTimeout(() => {
                            console.log("form embed not showed");
                            formEmbedControl(1);
                        }, 1);
                    });
                }, 1);
            });
        }
    }, timeout);
}

formEmbedControl(100);

document.addEventListener('DOMContentLoaded', () => {
    const formContainer = document.getElementById('app-embed');
  
    const observer = new MutationObserver((mutationsList, observer) => {
    const form = document.querySelector('form-embed');
  
  if (form) {
    observer.disconnect();
    const shadow = form.shadowRoot;
  
    const sheet = new CSSStyleSheet();
    sheet.insertRule(`
      section [data-sizing="form-wrapper"] {
        max-height: 70vh !important;
        height: 70vh !important;
      }
    `);
  
    shadow.adoptedStyleSheets.push(sheet);
    formContainer.classList.add('loaded');
  }
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
  });


document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('#contact_form');
    const button_submit = document.querySelector('.newsletter__button');
    console.log(form);

    button_submit.addEventListener('click', async(ev) => {
        const email = form.querySelector('.field__input').value;
        const privacy = form.querySelector('.field__checkbox').checked;
        
        
        if(email != "" && privacy == true){
            ev.preventDefault();
            let url = window.location.href;
            connectif.managed.sendEvents( [ { type: "custom", eventId: "671b46b2b0f939081c5e8c93", payload: { email: email } } ] )
            
            form.querySelector('.newsletter__text--additional').style.display = "none";
            form.querySelector('.newsletter-form__inner').style.display = "none";
            form.querySelector('.field_check').style.display = "none";

            let p = document.createElement('p');
            if(url.includes('/en')){
                console.log('en');
                p.textContent = "Thank you for subscribing to our newsletter!";
            }else if(url.includes('/fr')){
                console.log('fr');
                p.textContent = "Merci de vous être abonné à notre newsletter!";
            }else{
                console.log('es');
                p.textContent = "¡Gracias por suscribirte!";
            }
            form.after(p);
        }
    });
});


document.addEventListener('DOMContentLoaded', () => {
    window.setTimeout(() => {
        if (window.location.href === 'https://www.lineagrafica.es/pages/evento-sur-mundo' || window.location.href.includes('/pages/evento-sur-mundo')) {
            const iframe = document.querySelector('#app-embed');
            const button = iframe.shadowRoot.querySelector('button');
            
            console.log(button);
            button.addEventListener('click', () => {
                const email = iframe.shadowRoot.querySelector('input#email').value;
                const name = iframe.shadowRoot.querySelector('input#first_name').value;
                const surname = iframe.shadowRoot.querySelector('input#last_name').value;
                const empresa = iframe.shadowRoot.querySelector('input#custom\\#empresa').value;
                const puesto_profesional = iframe.shadowRoot.querySelector('input#custom\\#puesto').value;
                const mobilePhone = iframe.shadowRoot.querySelector('input#custom\\#telfono').value;

                console.log(email, name, surname, empresa, puesto_profesional, mobilePhone);
                connectif.managed.sendEvents( [ { 
                    type: "custom", 
                    eventId: "67dc0dc554c4de3319197510", 
                    payload: { 
                        email: email,
                        name: name,	
                        surname: surname,	
                        empresa: empresa,	
                        puestoProfesional: puesto_profesional,	
                        mobilePhone: mobilePhone,
                    } 
                } ] )
            });
        }
    }, 5000);
});

function equalizeProductCardHeights() {
  // Ahora igualamos las alturas de las tarjetas
  document.querySelectorAll('.swiper-wrapper').forEach(slider => {
    
    const cards = slider.querySelectorAll('.product-recommendations-lg');
    console.log(cards);
    if (!cards.length) return;
    cards.forEach(card => card.style.minHeight = 'auto');
    const max = Math.max(...Array.from(cards).map(c => c.offsetHeight));
    console.log('max height:', max);
    cards.forEach(c => c.style.minHeight = `${ max }px`);
  });
}
window.addEventListener('load', () => setTimeout(equalizeProductCardHeights, 1000));
window.addEventListener('resize', () => setTimeout(equalizeProductCardHeights, 1000));

// Control de formularios Shopify Forms
document.addEventListener('DOMContentLoaded', () => {

  // Oculta solo la X del botón flotante (teaser), pero mantiene el teaser visible
  const hideTeaserCloseButton = () => {
    document.querySelectorAll('shopify-forms-embed').forEach(embed => {
      const shadow = embed.shadowRoot;
      if (!shadow) return;

      // Buscar el teaser button
      const teaserButton = shadow.querySelector('button._teaserContainer_trejf_5');
      if (teaserButton) {
        // Ocultar solo el span con la X que está dentro del teaser
        const closeButtonInTeaser = teaserButton.querySelector('span._formCloseButton_1684x_4');
        if (closeButtonInTeaser) {
          closeButtonInTeaser.style.display = 'none';
          closeButtonInTeaser.style.visibility = 'hidden';
          closeButtonInTeaser.style.opacity = '0';
        }
      }
    });
  };

  // Limpiar localStorage cuando se cierra con la X
  const preventPermanentClose = (embed) => {
    const shadow = embed.shadowRoot;
    if (!shadow) return;

    const closeButton = shadow.querySelector('span[role="button"]._formCloseButton_1684x_4');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        setTimeout(() => {
          try {
            localStorage.removeItem('839312-dismissed-after-submit');
            localStorage.removeItem('839312-minimized-in-session');
            console.log('🔁 Formulario reseteado al cerrar');
          } catch (e) {
            console.warn('⚠️ No se pudo limpiar localStorage', e);
          }
        }, 300);
      });
    }
  };

  // Limpiar localStorage cuando se envía el formulario (estado "success")
  const preventPermanentDismissAfterSubmit = (embed) => {
    const shadow = embed.shadowRoot;
    if (!shadow) return;

    const appEmbedDiv = shadow.querySelector('#app-embed');
    if (!appEmbedDiv) return;

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'data-current-step'
        ) {
          const step = appEmbedDiv.getAttribute('data-current-step');
          if (step === 'success') {
            try {
              localStorage.removeItem('712500-dismissed-after-submit');
              localStorage.removeItem('712500-minimized-in-session');
              console.log('✅ Formulario reseteado después de envío');
            } catch (e) {
              console.warn('⚠️ No se pudo borrar localStorage', e);
            }
            observer.disconnect();
            break;
          }
        }
      }
    });

    observer.observe(appEmbedDiv, { attributes: true });
  };

  // Inicializar para todos los embeds de Shopify
  const initializeEmbeds = () => {
    document.querySelectorAll('shopify-forms-embed').forEach(embed => {
      if (!embed.shadowRoot) return;

      hideTeaserCloseButton();
      preventPermanentClose(embed);
      preventPermanentDismissAfterSubmit(embed);

      // Observar cambios en el shadowRoot para mantener estilos
      const observer = new MutationObserver(() => {
        hideTeaserCloseButton();
      });

      observer.observe(embed.shadowRoot, { childList: true, subtree: true });
    });
  };

  // Observar el body por si Shopify inyecta el widget tarde
  const globalObserver = new MutationObserver(() => {
    hideTeaserCloseButton();
    initializeEmbeds();
  });
  globalObserver.observe(document.body, { childList: true, subtree: true });

  // Inicializar al cargar
  hideTeaserCloseButton();
  initializeEmbeds();
});